module.exports = __webpack_public_path__ + "img/logo_yoomoney.8bc6c164.svg";